var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkDate())?_c('div',{staticClass:"flix-text-danger flix-html-strong flix-html-small"},[_vm._v(" "+_vm._s(_vm.$t("dates.error.end"))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }